import React, { Component } from "react";

import Ink from "react-ink";
import LightSpeed from "react-reveal/LightSpeed";
import WebShare from "../WebShare";
import { SiWhatsapp } from "react-icons/si";
import { SlArrowLeft } from "react-icons/sl";
import { BsSuitHeart, BsSuitHeartFill } from "react-icons/bs";
import { IMAGES_URL } from "../../../configs/website";

class BackWithSearch extends Component {
  static contextTypes = {
    router: () => null,
  };

  render() {
    const { colorBG, merchant } = this.props;
    return (
      <React.Fragment>
        <div className="col-12 p-0 fixed" style={{ zIndex: "9" }}>
          <div
            className="block m-0"
            style={{
              backgroundColor: colorBG === true ? "white" : "transparent",
            }}
          >
            <div
              className={`block-content p-0 ${this.props.dark && "nav-dark"}`}
            >
              <div
                className={`input-group ${
                  this.props.boxshadow && "search-box"
                }`}
              >
                {!this.props.disable_back_button && (
                  <div className="input-group-prepend">
                    {this.props.back_to_home && (
                      <button
                        type="button"
                        className="btn search-navs-btns"
                        style={{ position: "relative" }}
                        onClick={() => {
                          setTimeout(() => {
                            this.context.router.history.push("/");
                          }, 200);
                        }}
                      >
                        <i className="si si-arrow-left" />
                        <Ink duration="500" />
                      </button>
                    )}

                    {this.props.goto_orders_page && (
                      <button
                        type="button"
                        className="btn search-navs-btns"
                        style={{ position: "relative" }}
                        onClick={() => {
                          setTimeout(() => {
                            this.context.router.history.push("/my-orders");
                          }, 200);
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "rgb(255 255 255 / 75%)",
                            padding: "5px",
                            borderRadius: "999px",
                            display: "inline-flex",
                          }}
                        >
                          <i className="si si-arrow-left" />
                        </div>

                        <Ink duration="500" />
                      </button>
                    )}
                    {this.props.goto_accounts_page && (
                      <button
                        type="button"
                        className="btn search-navs-btns"
                        style={{ position: "relative" }}
                        onClick={() => {
                          setTimeout(() => {
                            this.context.router.history.push("/my-account");
                          }, 200);
                        }}
                      >
                        <SlArrowLeft className="fa-2x" />
                        <Ink duration="500" />
                      </button>
                    )}
                    {!this.props.back_to_home &&
                      !this.props.goto_orders_page &&
                      !this.props.goto_accounts_page && (
                        <button
                          type="button"
                          className={`btn search-navs-btns ${
                            this.props.dark && "nav-dark"
                          }`}
                          style={{
                            position: "relative",
                            backgroundColor: "transparent",
                          }}
                          onClick={() => {
                            setTimeout(() => {
                              this.context.router.history.goBack();
                            }, 200);
                          }}
                        >
                          <i
                            className="si si-arrow-left fa-1x"
                            style={{
                              backgroundColor: "rgb(255 255 255 / 75%)",
                              padding: "10px",
                              borderRadius: "999px",
                            }}
                          />
                          <Ink duration="500" />
                        </button>
                      )}
                  </div>
                )}
                <p
                  className={`form-control search-input d-flex align-items-center ${
                    this.props.dark && "nav-dark"
                  }`}
                  style={{ backgroundColor: "transparent" }}
                >
                  {this.props.logo && (
                    <img
                      src={
                        IMAGES_URL +
                        process.env.REACT_APP_IMAGE_LOGO +
                        "/public"
                      }
                      alt={localStorage.getItem("storeName")}
                      width="120"
                    />
                  )}
                  {this.props.has_title ? (
                    <React.Fragment>
                      {this.props.from_checkout ? (
                        <span
                          className="nav-page-title"
                          id="checkoutNavPageTitle"
                        >
                          {localStorage.getItem("cartToPayText")}{" "}
                          <span
                            style={{
                              color: localStorage.getItem("storeColor"),
                            }}
                          >
                            {localStorage.getItem("currencySymbolAlign") ===
                              "left" && localStorage.getItem("currencyFormat")}
                            {this.props.title}
                            {localStorage.getItem("currencySymbolAlign") ===
                              "right" && localStorage.getItem("currencyFormat")}
                          </span>
                        </span>
                      ) : (
                        <span className="nav-page-title">
                          {this.props.title}
                        </span>
                      )}
                    </React.Fragment>
                  ) : null}
                  {this.props.has_delivery_icon && (
                    <LightSpeed left>
                      <img
                        src="/assets/img/various/delivery-bike.png"
                        alt={this.props.title}
                        className="nav-page-title"
                      />
                    </LightSpeed>
                  )}
                </p>
                {this.props.has_merchant_info ? (
                  <div
                    className="fixed-merchant-info hidden"
                    ref={(node) => {
                      this.heading = node;
                    }}
                  >
                    <span className="font-w700 fixedMerchantName">
                      {merchant.name}
                    </span>
                    <br />
                    <span className="font-w400 fixedMerchantTime">
                      <i className="si si-clock" /> {merchant.delivery_time}{" "}
                      {localStorage.getItem("homePageMinsText")}
                    </span>
                  </div>
                ) : null}
                <div className="input-group-append">
                  {!this.props.disable_search && (
                    <button
                      type="submit"
                      className="btn search-navs-btns"
                      style={{ position: "relative" }}
                    >
                      <i className="si si-magnifier" />
                      <Ink duration="500" />
                    </button>
                  )}
                  {this.props.homeButton && (
                    <button
                      type="button"
                      className="btn search-navs-btns nav-home-btn"
                      style={{ position: "relative" }}
                      onClick={() => {
                        setTimeout(() => {
                          this.context.router.history.push("/");
                        }, 200);
                      }}
                    >
                      <i className="si si-home" />
                      <Ink duration="500" />
                    </button>
                  )}
                  {this.props.favoriteButton ? (
                    <button
                      type="button"
                      className="btn search-navs-btns nav-wpp-btn"
                      style={{
                        position: "relative",
                        backgroundColor: "transparent",
                      }}
                      onClick={() => {
                        this.props.favoriteAction();
                      }}
                    >
                      {" "}
                      <div
                        style={{
                          backgroundColor: "rgb(255 255 255 / 75%)",
                          padding: "5px",
                          borderRadius: "999px",
                          display: "inline-flex",
                        }}
                      >
                        {this.props.favoriteMerchant ? (
                          <BsSuitHeartFill
                            style={{ color: "red", fontSize: "1.6rem" }}
                          />
                        ) : (
                          <BsSuitHeart
                            style={{ color: "gray", fontSize: "1.6rem" }}
                          />
                        )}
                      </div>
                      <Ink duration="500" />
                    </button>
                  ) : null}

                  {this.props.merchantWhats ? (
                    <button
                      type="button"
                      className="btn search-navs-btns nav-wpp-btn"
                      style={{
                        position: "relative",
                        backgroundColor: "transparent",
                      }}
                      onClick={() => {
                        setTimeout(() => {
                          window.open(
                            "https://wa.me/+55" + this.props.merchantWhats,
                            "_blank",
                            "noreferrer"
                          );
                        }, 200);
                      }}
                    >
                      {" "}
                      <div
                        style={{
                          backgroundColor: "rgb(255 255 255 / 75%)",
                          padding: "5px",
                          borderRadius: "999px",
                          display: "inline-flex",
                        }}
                      >
                        <SiWhatsapp
                          className="fa-2x"
                          style={{
                            color: "#25D366",
                          }}
                        />
                      </div>
                      <Ink duration="500" />
                    </button>
                  ) : null}
                  {this.props.shareButton && (
                    <WebShare link={window.location.href} nobg={true} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default BackWithSearch;
